import React from 'react'

const Description = () => {
  return (
    <div>
        <div className="description">
        <h2>We Created Products Worth Holding Onto</h2>
        <div>
          The products we use on a daily basis say something about the people we
          are. We believe many things in life get better with time; it is that
          spirit we try to infuse in everything we create. In a world where we
          are overwhelmed by products made to break down or go out style, we aim
          to go against that grain.
        </div>
      </div>
    </div>
  )
}

export default Description